interface IConfig {
  reactAppEnvironment: "Localhost" | "Development" | "Test" | "Staging" | "Production",
  baseUrl: string,
  grpcBaseUrl: string,
  clientId: string,
  billsbyDomain: string,
  spreedlyKey: string,
  companyId: number
}

let ConfigConstants: IConfig = (window as any).ConfigConstants || {};
ConfigConstants.companyId = Number(ConfigConstants.companyId);

export {
  ConfigConstants
}